import Vue from 'vue'
import Vuex from 'vuex'
import Meta from 'vue-meta'
import ClientOnly from 'vue-client-only'
import NoSsr from 'vue-no-ssr'
import { createRouter } from './router.js'
import NuxtChild from './components/nuxt-child.js'
import NuxtError from '../layouts/error.vue'
import Nuxt from './components/nuxt.js'
import App from './App.js'
import { setContext, getLocation, getRouteData, normalizeError } from './utils'
import { createStore } from './store.js'

/* Plugins */

import nuxt_plugin_plugin_247d53d4 from 'nuxt_plugin_plugin_247d53d4' // Source: ./components/plugin.js (mode: 'all')
import nuxt_plugin_sentryserver_6b3a5aa4 from 'nuxt_plugin_sentryserver_6b3a5aa4' // Source: ./sentry.server.js (mode: 'server')
import nuxt_plugin_sentryclient_64a96126 from 'nuxt_plugin_sentryclient_64a96126' // Source: ./sentry.client.js (mode: 'client')
import nuxt_plugin_templatesplugin035dcb19_1515c0c1 from 'nuxt_plugin_templatesplugin035dcb19_1515c0c1' // Source: ./templates.plugin.035dcb19.js (mode: 'all')
import nuxt_plugin_image_9072cc36 from 'nuxt_plugin_image_9072cc36' // Source: ./image.js (mode: 'all')
import nuxt_plugin_recaptcha_6880b34e from 'nuxt_plugin_recaptcha_6880b34e' // Source: ./recaptcha.js (mode: 'all')
import nuxt_plugin_vuescrollto_02eeeddf from 'nuxt_plugin_vuescrollto_02eeeddf' // Source: ./vue-scrollto.js (mode: 'client')
import nuxt_plugin_nuxtsocketio_05c331b8 from 'nuxt_plugin_nuxtsocketio_05c331b8' // Source: ./nuxt-socket-io.js (mode: 'all')
import nuxt_plugin_gtm_4ef69640 from 'nuxt_plugin_gtm_4ef69640' // Source: ./gtm.js (mode: 'all')
import nuxt_plugin_axios_6680c62c from 'nuxt_plugin_axios_6680c62c' // Source: ./axios.js (mode: 'all')
import nuxt_plugin_vlazyload_210e3b50 from 'nuxt_plugin_vlazyload_210e3b50' // Source: ./v-lazy-load.js (mode: 'all')
import nuxt_plugin_workbox_1d1c7f86 from 'nuxt_plugin_workbox_1d1c7f86' // Source: ./workbox.js (mode: 'client')
import nuxt_plugin_metaplugin_dd4e3ece from 'nuxt_plugin_metaplugin_dd4e3ece' // Source: ./pwa/meta.plugin.js (mode: 'all')
import nuxt_plugin_iconplugin_d3fef3e6 from 'nuxt_plugin_iconplugin_d3fef3e6' // Source: ./pwa/icon.plugin.js (mode: 'all')
import nuxt_plugin_polyfills_7dce8c4e from 'nuxt_plugin_polyfills_7dce8c4e' // Source: ../plugins/polyfills (mode: 'client')
import nuxt_plugin_routeinfo_6abcdf4f from 'nuxt_plugin_routeinfo_6abcdf4f' // Source: ../plugins/route-info.js (mode: 'client')
import nuxt_plugin_scroll_ee90a558 from 'nuxt_plugin_scroll_ee90a558' // Source: ../plugins/scroll.js (mode: 'client')
import nuxt_plugin_globalfunctions_a67001a0 from 'nuxt_plugin_globalfunctions_a67001a0' // Source: ../plugins/global-functions.js (mode: 'client')
import nuxt_plugin_googletagfunctions_3eb4f8ad from 'nuxt_plugin_googletagfunctions_3eb4f8ad' // Source: ../plugins/google-tag-functions.js (mode: 'client')
import nuxt_plugin_streamfunctions_2436bb1a from 'nuxt_plugin_streamfunctions_2436bb1a' // Source: ../plugins/stream-functions.js (mode: 'client')
import nuxt_plugin_analyticsfunctions_6c1d8b4e from 'nuxt_plugin_analyticsfunctions_6c1d8b4e' // Source: ../plugins/analytics-functions.js (mode: 'client')
import nuxt_plugin_cookies_2c3cf8fe from 'nuxt_plugin_cookies_2c3cf8fe' // Source: ../plugins/cookies.js (mode: 'client')
import nuxt_plugin_scrollto_3d5d65b9 from 'nuxt_plugin_scrollto_3d5d65b9' // Source: ../plugins/scrollto.js (mode: 'client')
import nuxt_plugin_vuegallery_17c79102 from 'nuxt_plugin_vuegallery_17c79102' // Source: ../plugins/vue-gallery.js (mode: 'client')
import nuxt_plugin_vue2touchevents_147d6945 from 'nuxt_plugin_vue2touchevents_147d6945' // Source: ../plugins/vue2-touch-events.js (mode: 'client')
import nuxt_plugin_device_71515d2b from 'nuxt_plugin_device_71515d2b' // Source: ../plugins/device.js (mode: 'all')
import nuxt_plugin_nuxtimagepresets_850a50ee from 'nuxt_plugin_nuxtimagepresets_850a50ee' // Source: ../plugins/nuxt-image-presets.js (mode: 'all')
import nuxt_plugin_axios_5659d192 from 'nuxt_plugin_axios_5659d192' // Source: ../plugins/axios.js (mode: 'all')
import nuxt_plugin_navigation_4a5188a6 from 'nuxt_plugin_navigation_4a5188a6' // Source: ../plugins/navigation.js (mode: 'all')
import nuxt_plugin_platform_0bbad76e from 'nuxt_plugin_platform_0bbad76e' // Source: ../plugins/platform.js (mode: 'all')
import nuxt_plugin_seo_3c142120 from 'nuxt_plugin_seo_3c142120' // Source: ../plugins/seo.js (mode: 'all')
import nuxt_plugin_directives_521c0486 from 'nuxt_plugin_directives_521c0486' // Source: ../plugins/directives.js (mode: 'all')
import nuxt_plugin_auth_54a7c706 from 'nuxt_plugin_auth_54a7c706' // Source: ./auth.js (mode: 'all')

// Component: <ClientOnly>
Vue.component(ClientOnly.name, ClientOnly)

// TODO: Remove in Nuxt 3: <NoSsr>
Vue.component(NoSsr.name, {
  ...NoSsr,
  render (h, ctx) {
    if (process.client && !NoSsr._warned) {
      NoSsr._warned = true

      console.warn('<no-ssr> has been deprecated and will be removed in Nuxt 3, please use <client-only> instead')
    }
    return NoSsr.render(h, ctx)
  }
})

// Component: <NuxtChild>
Vue.component(NuxtChild.name, NuxtChild)
Vue.component('NChild', NuxtChild)

// Component NuxtLink is imported in server.js or client.js

// Component: <Nuxt>
Vue.component(Nuxt.name, Nuxt)

Object.defineProperty(Vue.prototype, '$nuxt', {
  get() {
    const globalNuxt = this.$root ? this.$root.$options.$nuxt : null
    if (process.client && !globalNuxt && typeof window !== 'undefined') {
      return window.$nuxt
    }
    return globalNuxt
  },
  configurable: true
})

Vue.use(Meta, {"keyName":"head","attribute":"data-n-head","ssrAttribute":"data-n-head-ssr","tagIDKeyName":"hid"})

const defaultTransition = {"name":"page","mode":"out-in","appear":false,"appearClass":"appear","appearActiveClass":"appear-active","appearToClass":"appear-to"}

const originalRegisterModule = Vuex.Store.prototype.registerModule

function registerModule (path, rawModule, options = {}) {
  const preserveState = process.client && (
    Array.isArray(path)
      ? !!path.reduce((namespacedState, path) => namespacedState && namespacedState[path], this.state)
      : path in this.state
  )
  return originalRegisterModule.call(this, path, rawModule, { preserveState, ...options })
}

async function createApp(ssrContext, config = {}) {
  const store = createStore(ssrContext)
  const router = await createRouter(ssrContext, config, { store })

  // Add this.$router into store actions/mutations
  store.$router = router

  // Fix SSR caveat https://github.com/nuxt/nuxt.js/issues/3757#issuecomment-414689141
  store.registerModule = registerModule

  // Create Root instance

  // here we inject the router and store to all child components,
  // making them available everywhere as `this.$router` and `this.$store`.
  const app = {
    head: {"title":"Meiden van Holland","meta":[{"charset":"utf-8"},{"name":"viewport","content":"width=device-width, initial-scale=1, maximum-scale=1"},{"hid":"description","name":"description","content":""},{"name":"theme-color","content":"#393939"},{"name":"msapplication-TileColor","content":"#ffffff"},{"name":"manifest","content":"\u002Fms-icon-144x144.png"},{"name":"theme-color","content":"#ffffff"},{"name":"testrobots","content":"https:\u002F\u002Fapiv2.sysero.nl"}],"script":[{"src":"\u002F\u002Fwww.gstatic.com\u002Fcv\u002Fjs\u002Fsender\u002Fv1\u002Fcast_sender.js?loadCastFramework=1"},{"src":"\u002F\u002Fmedia.maxx-xs.nl\u002Fmediaplayer\u002Fjs\u002Fpolyfill.js","charset":"UTF-8"},{"src":"\u002F\u002Fmedia.maxx-xs.nl\u002Fmediaplayer\u002Fjs\u002Fplayer.min.js","charset":"UTF-8"},{"src":"\u002F\u002Fmedia.maxx-xs.nl\u002Fmediaplayer\u002Fjs\u002Flang\u002Fen.js","charset":"UTF-8"},{"src":"\u002F\u002Fmedia.maxx-xs.nl\u002Fmediaplayer\u002Fjs\u002Flang\u002Fnl.js","charset":"UTF-8"},{"src":"\u002F\u002Fmedia.maxx-xs.nl\u002Fmediaplayer\u002Fjs\u002Flang\u002Fes.js","charset":"UTF-8"},{"src":"\u002F\u002Fmedia.maxx-xs.nl\u002Fmediaplayer\u002Fjs\u002Flang\u002Ffr.js","charset":"UTF-8"},{"src":"\u002F\u002Fmedia.maxx-xs.nl\u002Fmediaplayer\u002Fjs\u002Flang\u002Fde.js","charset":"UTF-8"},{"src":"\u002F\u002Fmedia.maxx-xs.nl\u002Fmediaplayer\u002Fsmartcast\u002Floader.js"},{"hid":"gtm-script","innerHTML":"if(!window._gtm_init){window._gtm_init=1;(function(w,n,d,m,e,p){w[d]=(w[d]==1||n[d]=='yes'||n[d]==1||n[m]==1||(w[e]&&w[e][p]&&w[e][p]()))?1:0})(window,navigator,'doNotTrack','msDoNotTrack','external','msTrackingProtectionEnabled');(function(w,d,s,l,x,y){w[x]={};w._gtm_inject=function(i){if(w.doNotTrack||w[x][i])return;w[x][i]=1;w[l]=w[l]||[];w[l].push({'gtm.start':new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],j=d.createElement(s);j.async=true;j.src='https:\u002F\u002Fwww.googletagmanager.com\u002Fgtm.js?id='+i;f.parentNode.insertBefore(j,f);};w[y]('GTM-T9ZH339P')})(window,document,'script','dataLayer','_gtm_ids','_gtm_inject')}"}],"link":[{"rel":"stylesheet","href":"\u002F\u002Fmedia.maxx-xs.nl\u002Fmediaplayer\u002Fcss\u002Fplayer.min.css"},{"rel":"stylesheet","href":"\u002F\u002Fmedia.maxx-xs.nl\u002Fmediaplayer\u002Fcss\u002Fcustom-demo.css"},{"rel":"preconnect","href":"https:\u002F\u002Ffonts.googleapis.com"},{"rel":"preconnect","href":"https:\u002F\u002Ffonts.gstatic.com","crossorigin":true},{"rel":"stylesheet","href":"https:\u002F\u002Ffonts.googleapis.com\u002Fcss2?family=Inter:ital,opsz,wght@1,14..32,900&display=swap"},{"rel":"icon","type":"image\u002Fx-icon","href":"\u002Ffavicon.ico"},{"rel":"apple-touch-icon","sizes":"57x57","href":"\u002Fapple-icon-57x57.png"},{"rel":"apple-touch-icon","sizes":"60x60","href":"\u002Fapple-icon-60x60.png"},{"rel":"apple-touch-icon","sizes":"72x72","href":"\u002Fapple-icon-72x72.png"},{"rel":"apple-touch-icon","sizes":"76x76","href":"\u002Fapple-icon-76x76.png"},{"rel":"apple-touch-icon","sizes":"114x114","href":"\u002Fapple-icon-114x114.png"},{"rel":"apple-touch-icon","sizes":"120x120","href":"\u002Fapple-icon-120x120.png"},{"rel":"apple-touch-icon","sizes":"144x144","href":"\u002Fapple-icon-144x144.png"},{"rel":"apple-touch-icon","sizes":"152x152","href":"\u002Fapple-icon-152x152.png"},{"rel":"apple-touch-icon","sizes":"180x180","href":"\u002Fapple-icon-180x180.png"},{"rel":"icon","type":"image\u002Fpng","sizes":"192x192","href":"\u002Fandroid-icon-192x192.png"},{"rel":"icon","type":"image\u002Fpng","sizes":"32x32","href":"\u002Ffavicon-32x32.png"},{"rel":"icon","type":"image\u002Fpng","sizes":"96x96","href":"\u002Ffavicon-96x96.png"},{"rel":"icon","type":"image\u002Fpng","sizes":"16x16","href":"\u002Ffavicon-16x16.png"}],"style":[],"noscript":[{"hid":"gtm-noscript","pbody":true,"innerHTML":"\u003Ciframe src=\"https:\u002F\u002Fwww.googletagmanager.com\u002Fns.html?id=GTM-T9ZH339P&\" height=\"0\" width=\"0\" style=\"display:none;visibility:hidden\" title=\"gtm\"\u003E\u003C\u002Fiframe\u003E"}],"__dangerouslyDisableSanitizersByTagID":{"gtm-script":["innerHTML"],"gtm-noscript":["innerHTML"]}},

    store,
    router,
    nuxt: {
      defaultTransition,
      transitions: [defaultTransition],
      setTransitions (transitions) {
        if (!Array.isArray(transitions)) {
          transitions = [transitions]
        }
        transitions = transitions.map((transition) => {
          if (!transition) {
            transition = defaultTransition
          } else if (typeof transition === 'string') {
            transition = Object.assign({}, defaultTransition, { name: transition })
          } else {
            transition = Object.assign({}, defaultTransition, transition)
          }
          return transition
        })
        this.$options.nuxt.transitions = transitions
        return transitions
      },

      err: null,
      errPageReady: false,
      dateErr: null,
      error (err) {
        err = err || null
        app.context._errored = Boolean(err)
        err = err ? normalizeError(err) : null
        let nuxt = app.nuxt // to work with @vue/composition-api, see https://github.com/nuxt/nuxt.js/issues/6517#issuecomment-573280207
        if (this) {
          nuxt = this.nuxt || this.$options.nuxt
        }
        nuxt.dateErr = Date.now()
        nuxt.err = err
        nuxt.errPageReady = false
        // Used in src/server.js
        if (ssrContext) {
          ssrContext.nuxt.error = err
        }
        return err
      }
    },
    ...App
  }

  // Make app available into store via this.app
  store.app = app

  const next = ssrContext ? ssrContext.next : location => app.router.push(location)
  // Resolve route
  let route
  if (ssrContext) {
    route = router.resolve(ssrContext.url).route
  } else {
    const path = getLocation(router.options.base, router.options.mode)
    route = router.resolve(path).route
  }

  // Set context to app.context
  await setContext(app, {
    store,
    route,
    next,
    error: app.nuxt.error.bind(app),
    payload: ssrContext ? ssrContext.payload : undefined,
    req: ssrContext ? ssrContext.req : undefined,
    res: ssrContext ? ssrContext.res : undefined,
    beforeRenderFns: ssrContext ? ssrContext.beforeRenderFns : undefined,
    beforeSerializeFns: ssrContext ? ssrContext.beforeSerializeFns : undefined,
    ssrContext
  })

  function inject(key, value) {
    if (!key) {
      throw new Error('inject(key, value) has no key provided')
    }
    if (value === undefined) {
      throw new Error(`inject('${key}', value) has no value provided`)
    }

    key = '$' + key
    // Add into app
    app[key] = value
    // Add into context
    if (!app.context[key]) {
      app.context[key] = value
    }

    // Add into store
    store[key] = app[key]

    // Check if plugin not already installed
    const installKey = '__nuxt_' + key + '_installed__'
    if (Vue[installKey]) {
      return
    }
    Vue[installKey] = true
    // Call Vue.use() to install the plugin into vm
    Vue.use(() => {
      if (!Object.prototype.hasOwnProperty.call(Vue.prototype, key)) {
        Object.defineProperty(Vue.prototype, key, {
          get () {
            return this.$root.$options[key]
          }
        })
      }
    })
  }

  // Inject runtime config as $config
  inject('config', config)

  if (process.client) {
    // Replace store state before plugins execution
    if (window.__NUXT__ && window.__NUXT__.state) {
      store.replaceState(window.__NUXT__.state)
    }
  }

  // Add enablePreview(previewData = {}) in context for plugins
  if (process.static && process.client) {
    app.context.enablePreview = function (previewData = {}) {
      app.previewData = Object.assign({}, previewData)
      inject('preview', previewData)
    }
  }
  // Plugin execution

  if (typeof nuxt_plugin_plugin_247d53d4 === 'function') {
    await nuxt_plugin_plugin_247d53d4(app.context, inject)
  }

  if (process.server && typeof nuxt_plugin_sentryserver_6b3a5aa4 === 'function') {
    await nuxt_plugin_sentryserver_6b3a5aa4(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_sentryclient_64a96126 === 'function') {
    await nuxt_plugin_sentryclient_64a96126(app.context, inject)
  }

  if (typeof nuxt_plugin_templatesplugin035dcb19_1515c0c1 === 'function') {
    await nuxt_plugin_templatesplugin035dcb19_1515c0c1(app.context, inject)
  }

  if (typeof nuxt_plugin_image_9072cc36 === 'function') {
    await nuxt_plugin_image_9072cc36(app.context, inject)
  }

  if (typeof nuxt_plugin_recaptcha_6880b34e === 'function') {
    await nuxt_plugin_recaptcha_6880b34e(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vuescrollto_02eeeddf === 'function') {
    await nuxt_plugin_vuescrollto_02eeeddf(app.context, inject)
  }

  if (typeof nuxt_plugin_nuxtsocketio_05c331b8 === 'function') {
    await nuxt_plugin_nuxtsocketio_05c331b8(app.context, inject)
  }

  if (typeof nuxt_plugin_gtm_4ef69640 === 'function') {
    await nuxt_plugin_gtm_4ef69640(app.context, inject)
  }

  if (typeof nuxt_plugin_axios_6680c62c === 'function') {
    await nuxt_plugin_axios_6680c62c(app.context, inject)
  }

  if (typeof nuxt_plugin_vlazyload_210e3b50 === 'function') {
    await nuxt_plugin_vlazyload_210e3b50(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_workbox_1d1c7f86 === 'function') {
    await nuxt_plugin_workbox_1d1c7f86(app.context, inject)
  }

  if (typeof nuxt_plugin_metaplugin_dd4e3ece === 'function') {
    await nuxt_plugin_metaplugin_dd4e3ece(app.context, inject)
  }

  if (typeof nuxt_plugin_iconplugin_d3fef3e6 === 'function') {
    await nuxt_plugin_iconplugin_d3fef3e6(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_polyfills_7dce8c4e === 'function') {
    await nuxt_plugin_polyfills_7dce8c4e(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_routeinfo_6abcdf4f === 'function') {
    await nuxt_plugin_routeinfo_6abcdf4f(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_scroll_ee90a558 === 'function') {
    await nuxt_plugin_scroll_ee90a558(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_globalfunctions_a67001a0 === 'function') {
    await nuxt_plugin_globalfunctions_a67001a0(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_googletagfunctions_3eb4f8ad === 'function') {
    await nuxt_plugin_googletagfunctions_3eb4f8ad(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_streamfunctions_2436bb1a === 'function') {
    await nuxt_plugin_streamfunctions_2436bb1a(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_analyticsfunctions_6c1d8b4e === 'function') {
    await nuxt_plugin_analyticsfunctions_6c1d8b4e(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_cookies_2c3cf8fe === 'function') {
    await nuxt_plugin_cookies_2c3cf8fe(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_scrollto_3d5d65b9 === 'function') {
    await nuxt_plugin_scrollto_3d5d65b9(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vuegallery_17c79102 === 'function') {
    await nuxt_plugin_vuegallery_17c79102(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vue2touchevents_147d6945 === 'function') {
    await nuxt_plugin_vue2touchevents_147d6945(app.context, inject)
  }

  if (typeof nuxt_plugin_device_71515d2b === 'function') {
    await nuxt_plugin_device_71515d2b(app.context, inject)
  }

  if (typeof nuxt_plugin_nuxtimagepresets_850a50ee === 'function') {
    await nuxt_plugin_nuxtimagepresets_850a50ee(app.context, inject)
  }

  if (typeof nuxt_plugin_axios_5659d192 === 'function') {
    await nuxt_plugin_axios_5659d192(app.context, inject)
  }

  if (typeof nuxt_plugin_navigation_4a5188a6 === 'function') {
    await nuxt_plugin_navigation_4a5188a6(app.context, inject)
  }

  if (typeof nuxt_plugin_platform_0bbad76e === 'function') {
    await nuxt_plugin_platform_0bbad76e(app.context, inject)
  }

  if (typeof nuxt_plugin_seo_3c142120 === 'function') {
    await nuxt_plugin_seo_3c142120(app.context, inject)
  }

  if (typeof nuxt_plugin_directives_521c0486 === 'function') {
    await nuxt_plugin_directives_521c0486(app.context, inject)
  }

  if (typeof nuxt_plugin_auth_54a7c706 === 'function') {
    await nuxt_plugin_auth_54a7c706(app.context, inject)
  }

  // Lock enablePreview in context
  if (process.static && process.client) {
    app.context.enablePreview = function () {
      console.warn('You cannot call enablePreview() outside a plugin.')
    }
  }

  // Wait for async component to be resolved first
  await new Promise((resolve, reject) => {
    // Ignore 404s rather than blindly replacing URL in browser
    if (process.client) {
      const { route } = router.resolve(app.context.route.fullPath)
      if (!route.matched.length) {
        return resolve()
      }
    }
    router.replace(app.context.route.fullPath, resolve, (err) => {
      // https://github.com/vuejs/vue-router/blob/v3.4.3/src/util/errors.js
      if (!err._isRouter) return reject(err)
      if (err.type !== 2 /* NavigationFailureType.redirected */) return resolve()

      // navigated to a different route in router guard
      const unregister = router.afterEach(async (to, from) => {
        if (process.server && ssrContext && ssrContext.url) {
          ssrContext.url = to.fullPath
        }
        app.context.route = await getRouteData(to)
        app.context.params = to.params || {}
        app.context.query = to.query || {}
        unregister()
        resolve()
      })
    })
  })

  return {
    store,
    app,
    router
  }
}

export { createApp, NuxtError }
